import { render, staticRenderFns } from "./UserNotFound.vue?vue&type=template&id=2ce0773c&"
import script from "./UserNotFound.vue?vue&type=script&lang=ts&"
export * from "./UserNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./UserNotFound.vue?vue&type=style&index=0&id=2ce0773c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports